module.exports = __webpack_public_path__ + "img/no_data.a4cede34.png";